import { render, staticRenderFns } from "./Box12.vue?vue&type=template&id=5194dbac&scoped=true&"
import script from "./Box12.vue?vue&type=script&lang=js&"
export * from "./Box12.vue?vue&type=script&lang=js&"
import style0 from "./Box12.vue?vue&type=style&index=0&id=5194dbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194dbac",
  null
  
)

export default component.exports